<template>
	<div>
		<Template title="null" sidebarMenu="program-managements">
			<div class="bg-light-hight- hstack py-3 ps-2 pb-3">
				<router-link
					to="/program-managements/sale"
					class="bg-light-hight- ms-2 text-6 top-item"
					>{{ $t('programs.saling.sale') }}</router-link
				>
				<router-link
					to="/program-managements/buying"
					class="bg-light-hight- ms-4 text-6 top-item"
					>{{ $t('programs.buying.buy') }}</router-link
				>
				<router-link
					to="/program-managements/buying-archives"
					class="bg-light-hight- ms-4 text-6 top-item"
					>{{ $t('global.archive') }}</router-link
				>
			</div>

			<section class="row px-4 m-0 g-4 mt-1">
				<div class="col-xl-9">
					<div v-if="!loading && recents.length != 0">
						<div
							class="bg-second- shadow-sm text-uppercase text-center rounded-pill text-5 text-white px-4 p-1"
						>
							{{ $t('global.recent') }}
						</div>
						<div class="row mt-1 g-2 mb-4">
							<div
								class="col-3"
								v-for="(buying, index) in recents"
								:key="index"
							>
								<div class="rate_item bg-light-hight-1 rounded">
									<div class="hstack w-75 mx-auto p-3">
										<div class="text-center w-75 mx-auto p-3">
											<img src="@/assets/img/ModuleBuying.png" alt="" />
										</div>
									</div>
									<div
										class="bg-second- text-center text-truncate text-white rounded p-2 text-5"
									>
										<router-link
											:to="{
												name: 'buying-show',
												params: { id: buying.id, slug: buying.slug },
											}"
										>
											{{ buying.number }}
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="hstack p-2 px-4 rounded shadow-1 bg-white">
						<input
							type="checkbox"
							:checked="allIsCheck"
							@click="check(0, true)"
						/>
						<i
							class="uil uil-archive ms-3 fs-6"
							type="button"
							@click="archives()"
						></i>

						<div class="hstack ms-auto">
							<label for="" class="text-5 me-2">{{
								$t('global.filter')
							}}</label>
							<select class="form-control text-6" v-model="orderBy">
								<option value="id">{{ $t('global.order_of_addition') }}</option>
								<option value="number">{{ $t('global.number') }}</option>
								<option value="tva">TVA</option>
								<option value="amountTTC">
									{{ $t('programs.amount_including_tax') }}
								</option>
								<option value="amountHT">
									{{ $t('programs.amount_excluding_tax') }}
								</option>
								<option value="date">{{ $t('global.date') }}</option>
							</select>

							<label for="" class="text-5 ms-2 me-2">{{
								$t('global.order')
							}}</label>
							<select class="form-control text-6" v-model="order">
								<option value="ASC">Asc</option>
								<option value="DESC">Desc</option>
							</select>
						</div>

						<div class="ms-auto hstack">
							<i
								class="uil uil-arrow-circle-left fs-5"
								type="button"
								@click="previous"
							></i>
							<small class="ms-3"
								>{{ Math.ceil(buyings.length / 25) > 0 ? page : 0 }} /
								{{ Math.ceil(buyings.length / 25) }}</small
							>
							<i
								class="uil uil-arrow-circle-right fs-5 ms-3"
								type="button"
								@click="next"
							></i>
							<div class="hstack ms-5">
								<i
									class="uil uil-apps fs-6 p-1 px-3 rounded"
									:class="
										store.disposition == 'grid'
											? 'bg-black- text-white-'
											: 'bg-white- text-black-'
									"
									@click="store.setDisposition('grid')"
									type="button"
								></i>
								<i
									class="uil uil-list-ul fs-6 ms-1 p-1 px-3 rounded"
									:class="
										store.disposition == 'list'
											? 'bg-black- text-white-'
											: 'bg-white- text-black-'
									"
									@click="store.setDisposition('list')"
									type="button"
								></i>
							</div>
						</div>
					</div>

					<LoadingMain :state="loading" />

					<div v-if="!loading && buyings.length != 0">
						<div
							class="table-responsive-lg mt-0 mb-4"
							v-if="store.disposition == 'list'"
						>
							<table
								class="table buyings align-middle table-hover table-striped mb-0"
								style="width: 100% !important"
							>
								<thead class="bg-primary- text-center">
									<tr class="text-6 text-white">
										<th></th>
										<th>{{ $t('programs.buying.invoice') }}</th>
										<th>{{ $t('programs.buying.supplier') }}</th>
										<th>{{ $t('programs.buying.mode') }}</th>
										<th>{{ $t('global.date') }}</th>
										<th>{{ $t('programs.amount_excluding_tax') }}</th>
										<th>TVA</th>
										<th>{{ $t('programs.amount_including_tax') }}</th>
									</tr>
								</thead>
								<tbody class="bg-alt- text-center">
									<tr
										class="text-6 text-black"
										v-for="(buying, index) in buyings"
										:key="index"
										v-show="show(index)"
									>
										<td>
											<input
												type="checkbox"
												:checked="isSelected(buying.id)"
												@click="check(buying.id)"
											/>
										</td>
										<td>
											<router-link
												:to="{
													name: 'buying-show',
													params: { id: buying.id, slug: buying.slug },
												}"
											>
												{{ buying.number }}
											</router-link>
										</td>
										<td>{{ buying.supplier }}</td>
										<td>{{ buying.paymentMean }}</td>
										<td>{{ $filters.convertDate(buying.createdAt) }}</td>
										<td>{{ $filters.formatAmount(buying.amountHT, false) }}</td>
										<td>{{ $filters.formatAmount(buying.tva, false) }}</td>
										<td>
											{{ $filters.formatAmount(buying.amountTTC, false) }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="row mt-1 g-2" v-else>
							<div
								class="col-md-3"
								v-for="(buying, index) in buyings"
								:key="index"
								v-show="show(index)"
							>
								<div class="rate_item bg-light-hight-1 rounded">
									<div class="text-center w-75 mx-auto p-3">
										<img src="@/assets/img/ModuleBuying.png" alt="" />
									</div>
									<div
										class="bg-second- text-center text-truncate text-white rounded p-2 text-5"
									>
										<input
											class="me-2"
											type="checkbox"
											:checked="isSelected(buying.id)"
											@click="check(buying.id)"
										/>
										<router-link
											:to="{
												name: 'buying-show',
												params: { id: buying.id, slug: buying.slug },
											}"
										>
											{{ buying.number }}
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div
						class="py-4 mt-1 text-center bg-white- text-5"
						v-if="!loading && buyings.length == 0"
					>
						{{ $t('global.no_data_found') }}
					</div>
				</div>

				<div class="col-xl-3">
					<div class="rounded bg-second- text-white text-4 text-center p-1">
						{{ $t('global.advice') }}
					</div>
					<div
						class="mt-1 bg-light-hight- text-alt- rounded text-7 text-center p-2"
						v-html="$t('programs.buying.archive_advice_text')"
					></div>
					<router-link to="/documents/create"
						><button class="button bg-alt- btn-sm w-100 mt-1 p-1">
							{{ $t('global.add_now') }}
						</button>
					</router-link>
				</div>
			</section>
		</Template>
	</div>
</template>
<script>
import Template from '@/components/Template.vue';
import LoadingMain from '@/components/LoadingMain.vue';
import Helper from '@/helpers/helper';
import { useDispositionStore } from '@/store/disposition';

export default {
	setup() {
		const store = useDispositionStore();
		return { store };
	},
	name: 'HomePage',
	components: { Template, LoadingMain },
	data() {
		return {
			selectedList: [],
			allIsCheck: false,
			page: 1,
			perPage: 25,
			deleted: false,
			archived: false,
			loading: false,
			disposition: 'list',
			orderBy: 'id',
			order: 'DESC',
			recents: [],
			buyings: [],
		};
	},
	methods: {
		check(id, all = false) {
			if (all) {
				if (this.selectedList.length !== this.buyings.length) {
					this.selectedList.length = 0;
					this.buyings.forEach((employee) => {
						this.selectedList.push({ id: employee.id });
					});
				} else {
					this.selectedList.length = 0;
				}
			} else {
				let found = false;
				this.selectedList.forEach((element) => {
					if (element.id == id) {
						found = true;
					}
				});
				if (found) {
					this.selectedList.filter((value, index) => {
						if (value.id == id) {
							this.selectedList.splice(index, 1);
						}
					});
				} else {
					this.selectedList.push({ id: id });
				}
			}
			if (this.selectedList.length === this.buyings.length) {
				this.allIsCheck = true;
			} else {
				this.allIsCheck = false;
			}
		},
		show(index) {
			return (
				index < this.page * this.perPage &&
				index + 1 > (this.page - 1) * this.perPage
			);
		},
		next() {
			if (this.page * this.perPage < this.buyings.length) {
				this.page++;
			}
		},
		previous() {
			if (this.page >= 2) {
				this.page--;
			}
		},
		isSelected(id) {
			let found = false;
			this.selectedList.forEach((element) => {
				if (element.id == id) {
					found = true;
				}
			});
			return found;
		},
		loadList() {
			this.loading = true;
			fetch(
				Helper.route(
					'admin/buying/all?archived=true&sortBy=' +
						this.orderBy +
						'&order=' +
						this.order
				),
				Helper.requestOptions()
			)
				.then((response) => {
					Helper.tokenChecker(response.status);
					return response.json();
				})
				.then((data) => {
					this.loading = false;
					console.log(data);
					if (data.buyings) {
						this.buyings = data.buyings;
						this.recents = data.recents;
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		archives() {
			if (this.selectedList.length < 1) {
				Helper.notification(
					'error',
					'Selectionnez au moins un élément pour continuer'
				);
				return;
			}

			this.$isLoading(true);
			let body = {
				ids: this.selectedList.map((element) => element.id),
			};
			fetch(
				Helper.route('admin/buying/archive'),
				Helper.requestOptionsJSON('PUT', body)
			)
				.then((response) => {
					Helper.tokenChecker(response.status);
					return response.json();
				})
				.then((data) => {
					this.$isLoading(false);
					console.log(data);
					this.archived = true;
					for (let i = 0; i < this.selectedList.length; i++) {
						const element = this.selectedList[i];
						this.buyings = this.buyings.filter((i) => i.id !== element.id);
						this.recents = this.recents.filter((i) => i.id !== element.id);
					}
					this.selectedList = [];
					Helper.notification('success', data.message);
				})
				.catch((error) => {
					this.$isLoading(false);
					console.log(error);
				});
		},
	},
	created() {
		this.loadList();
	},
	watch: {
		orderBy: function () {
			this.loadList();
		},
		order: function () {
			this.loadList();
		},
	},
};
</script>
<style>
.rate_item img {
	height: 70px;
	width: 70px;
	object-fit: cover;
}
.buyings th,
.buyings td {
	color: white !important;
}
.employe_item img {
	height: 100px;
	width: 100px;
}
</style>
